import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { v4 } from 'uuid';
import checkMark from '../../../images/checkmarkWhite.png';

const Bullets = styled.ul`
  font-size: 24px;
  padding: 0;
  margin-top: 50px;
  font-family: Roobert, sans-serif;
  text-align: left;
  list-style-type: none;

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  img {
    width: 40px;
    height: 40px;
  }

  p {
    width: calc(100% - 60px);
    margin: 0;
    font-size: 24px;
    color: white;
  }

  li + li {
    margin-top: 50px;
  }
`;

const SplashBullets = ({ bullets }) => (
  <Bullets>
    {bullets.map(bullet => (
      <li key={v4()}>
        <img src={checkMark} alt="checkmark" />
        <p>{bullet}</p>
      </li>
    ))}
  </Bullets>
);

SplashBullets.propTypes = {
  bullets: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SplashBullets;
